import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

/**
 * Kleiner Hinweis unten rechts. Schließt sich nach 5 s von selbst.
 */
export default function Toast({ message, type, onClose }: ToastProps) {
  useEffect(() => {
    const t = window.setTimeout(onClose, 5000);
    return () => window.clearTimeout(t);
  }, [onClose]);

  return (
    <div
      className="fixed bottom-4 right-4 z-50 max-w-md bg-paper sv-hairline border-l-2 p-4 shadow-lg"
      style={{ borderLeftColor: type === 'error' ? '#77B72B' : '#3A3C3E' }}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="sv-serif text-[13px] text-ink leading-snug flex-1">
          {message}
        </p>
        <button
          type="button"
          onClick={onClose}
          aria-label="Schließen"
          className="sv-mono text-[13px] text-ink-3 hover:text-ink"
        >
          ×
        </button>
      </div>
    </div>
  );
}
